import React from "react";
import { Modal } from "react-bootstrap";
import { useCancelSubscriptionMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { SubscriptionIcon } from "../../../../util/Icons";

const CancelSubscriptionModal = ({ showCancelSubscriptionModal, onHide, details, tableRef }) => {
    const [
        cancelSubscription, // This is the mutation trigger
        {
            isLoading: isCancelling,
        }, // This is the destructured mutation result
    ] = useCancelSubscriptionMutation()

    /* Cancel Subscription */
    const cancel = () => {
        cancelSubscription({
            userId: details?.userId,
            subId: details?.id,
            meta: details,
        })
            .unwrap()
            .then(() => {
                cogoToast.success("Created 'Cancel Subscription' action successfully")
                tableRef.current.refresh()
                onHide()
            })
    }

    return (
        <Modal
            show={showCancelSubscriptionModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isCancelling ? "static" : true}
            keyboard={!isCancelling}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SubscriptionIcon />
                    </span>
                    Cancel Subscription
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>

            <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                <p>Are you sure you want to cancel <strong>{details?.product}</strong> subscription for <strong>{details?.username}</strong></p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    onClick={onHide}
                    disabled={isCancelling}
                    className="btn btn-light btn-elevate px-4"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    disabled={isCancelling}
                    className="btn btn-danger btn-elevate px-4 ml-4"
                    onClick={cancel}
                >
                    Cancel Subscription
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default CancelSubscriptionModal;
